<div *ngIf="loading" class="login-loader text-center"><img src="assets/images/filter/filter-loading.svg" alt="Loader" width="100" height="100" /></div>    
<div *ngIf="!loading" class="main-container"> 
    <div class="under-maintenance-container">                 
        <!--div class="um-section-img" [style.background-image]="'url(' + serviceLogo + ')'"></div-->
        <div class="um-section-img"></div>
        <div class="um-section">
            <span class="um-section-span um-img"><img [src]="logo" /></span>
            <span class="um-section-span um-text">{{platformName}}&nbsp;<span style="color:#ff0000;">{{maintainText}}</span></span>
        </div>
    </div>    
</div>
